import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
  SelectFormikField,
  SelectFormikFieldProps,
  SelectItem,
  SelectProps,
} from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";

type Props = {
  name: SelectFormikFieldProps<object>["name"];
  label: SelectProps<object>["label"];
  testID: SelectProps<object>["testID"];
  isRequired?: SelectProps<object>["isRequired"];
  isDisabled?: SelectProps<object>["isDisabled"];
  showInfo?: boolean;
};

export function PermissiblePurposeSelect(props: Props) {
  const { t } = useTranslation();
  const {
    clientPortalPreventGroupCreationWithNonEmploymentTenancyPermissiblePurpose,
  } = useFlags();
  const { name, label, isRequired, testID, isDisabled, showInfo } = props;
  return (
    <SelectFormikField
      name={name}
      label={label}
      isRequired={isRequired}
      testID={testID}
      isDisabled={isDisabled}
      info={
        showInfo ? (
          <DialogTrigger>
            <LinkButton testID="" textStyle="form/body-secondary-link">
              {t("What's this?")}
            </LinkButton>
            <Popover placement="top right">
              <PopoverContent>
                {t(
                  "Permissible purpose is the legal reason for conducting background screening which may differ between employment, tenancy, lending, investing, and insurance purposes. This ensures that all screenings are carried out in compliance with industry regulations and that the information obtained is used ethically and responsibly."
                )}
              </PopoverContent>
            </Popover>
          </DialogTrigger>
        ) : undefined
      }
    >
      <SelectItem id="EMPLOYMENT">{t("Employment (HR)")}</SelectItem>
      <SelectItem id="TENANCY">{t("Tenancy (PM)")}</SelectItem>
      {!clientPortalPreventGroupCreationWithNonEmploymentTenancyPermissiblePurpose && (
        <>
          <SelectItem id="LENDING">{t("Lending")}</SelectItem>
          <SelectItem id="INVESTING">{t("Investing")}</SelectItem>
          <SelectItem id="INSURANCE">{t("Insurance")}</SelectItem>
          <SelectItem id="CONSUMER">{t("As directed by consumer")}</SelectItem>
        </>
      )}
    </SelectFormikField>
  );
}
